module.exports = __webpack_public_path__ + "img/s2.98cebdfa.jpg";